module.exports = __webpack_public_path__ + "img/index_icon4@2x.cd4785b0.png";